export default ['de', 'it', 'hu'];
